import { updateBasketItemQuantity } from 'utils/basket';
import {
  getProductsWithIncreasedQuantity,
  logEvent,
  prepareProductsForCartAnalytics,
  queueBasketUpdate,
} from '../helpers';
import { postCartAnalytics } from '../../../../../api/basket';

export type BasketAddProductsEventArg = { code: string, quantity: number }[];

function isBasketAddProductsEvent(e: Event): e is CustomEvent<BasketAddProductsEventArg> {
  if ('detail' in e) {
    const detail = e.detail;
    if (Array.isArray(detail) && (!detail.length || typeof detail[0] === 'object')) {
      const item = detail[0];
      return 'code' in item && typeof item.code === 'string' && 'quantity' in item && typeof item.quantity === 'number'
    }
  }
  return false;
}

export const handleBasketAddProducts = (e: Event) => {
  if (isBasketAddProductsEvent(e)) {
    const products = e.detail;
    logEvent('basket:add_products', products);
    const productsWithIncreasedQuantity = getProductsWithIncreasedQuantity(products);

    if (productsWithIncreasedQuantity.length > 0) {
      postCartAnalytics(prepareProductsForCartAnalytics(productsWithIncreasedQuantity));
    }
    queueBasketUpdate((basket) => {

      return products.reduce((currentBasket, { code, quantity }) => updateBasketItemQuantity(currentBasket, code, quantity, true), basket);
    });
  } else {
    console.error('Invalid arguments in basket:add_products event');
  }
};
